import {
    ensureWidgetType,
    WidgetArticleAttachmentType,
    widgetArticleAttachmentTypeSchema,
    WidgetArticleButtonType,
    widgetArticleButtonTypeSchema,
    WidgetArticleGalleryType,
    widgetArticleGalleryTypeSchema,
    WidgetArticleImageType,
    widgetArticleImageTypeSchema,
    WidgetArticleSliderType,
    widgetArticleSliderTypeSchema,
    WidgetArticleTextType,
    widgetArticleTextTypeSchema,
    WidgetArticleTitleType,
    widgetArticleTitleTypeSchema,
    WidgetCalendarCalDavType,
    widgetCalendarCalDavTypeSchema,
    WidgetCheckListType,
    widgetCheckListTypeSchema,
    WidgetContactCardDavType,
    widgetContactCardDavTypeSchema,
    WidgetDatasourceTableType,
    widgetDatasourceTableTypeSchema,
    WidgetEmailsImapType,
    widgetEmailsImapTypeSchema,
    WidgetExcelDatasourceTableType,
    widgetExcelDatasourceTableTypeSchema,
    WidgetLuccaAbsenceType,
    widgetLuccaAbsenceTypeSchema,
    WidgetQuickSurveyType,
    widgetQuickSurveyTypeSchema,
    WidgetWrapperProps,
    widgetWrapperPropsSchema,
} from '../types';

export const ensureWidgetWrapperProps = (o: unknown): o is WidgetWrapperProps => {
    return widgetWrapperPropsSchema.safeParse(o).success;
};

export const ensureWidgetArticleAttachmentType = (widget: unknown): widget is WidgetArticleAttachmentType =>
    ensureWidgetType(widget, widgetArticleAttachmentTypeSchema);

export const ensureWidgetArticleButtonType = (widget: unknown): widget is WidgetArticleButtonType =>
    ensureWidgetType(widget, widgetArticleButtonTypeSchema);

export const ensureWidgetLuccaAbsenceType = (widget: unknown): widget is WidgetLuccaAbsenceType =>
    ensureWidgetType(widget, widgetLuccaAbsenceTypeSchema);

export const ensureWidgetArticleGalleryType = (widget: unknown): widget is WidgetArticleGalleryType =>
    ensureWidgetType(widget, widgetArticleGalleryTypeSchema);

export const ensureWidgetArticleImageType = (widget: unknown): widget is WidgetArticleImageType =>
    ensureWidgetType(widget, widgetArticleImageTypeSchema);

export const ensureWidgetArticleSliderType = (widget: unknown): widget is WidgetArticleSliderType =>
    ensureWidgetType(widget, widgetArticleSliderTypeSchema);

export const ensureWidgetArticleTextType = (widget: unknown): widget is WidgetArticleTextType =>
    ensureWidgetType(widget, widgetArticleTextTypeSchema);

export const ensureWidgetArticleTitleType = (widget: unknown): widget is WidgetArticleTitleType =>
    ensureWidgetType(widget, widgetArticleTitleTypeSchema);

export const ensureWidgetCheckListType = (widget: unknown, logError?: boolean): widget is WidgetCheckListType =>
    ensureWidgetType(widget, widgetCheckListTypeSchema, logError);

export const ensureWidgetDatasourceTableType = (widget: unknown): widget is WidgetDatasourceTableType =>
    ensureWidgetType(widget, widgetDatasourceTableTypeSchema);

export const ensureWidgetExcelDatasourceTableType = (widget: unknown): widget is WidgetExcelDatasourceTableType =>
    ensureWidgetType(widget, widgetExcelDatasourceTableTypeSchema);

export const ensureWidgetQuickSurveyType = (widget: unknown): widget is WidgetQuickSurveyType =>
    ensureWidgetType(widget, widgetQuickSurveyTypeSchema);

export const ensureWidgetCalendarCalDavType = (widget: unknown): widget is WidgetCalendarCalDavType =>
    ensureWidgetType(widget, widgetCalendarCalDavTypeSchema);

export const ensureWidgetContactCardDavType = (widget: unknown): widget is WidgetContactCardDavType =>
    ensureWidgetType(widget, widgetContactCardDavTypeSchema);

export const ensureWidgetEmailsImapType = (widget: unknown): widget is WidgetEmailsImapType =>
    ensureWidgetType(widget, widgetEmailsImapTypeSchema);
